<template>
    <div class="widget template-publish-widget">
        <div class="widget-header">
            <h3>Publish to Partners</h3>
            <div class="svg-container widget-close-button" @click="closeWidget">
                <widget-close-svg />
            </div>
        </div>
        <div class="content-wrapper">
            <p>Please select which partners you would like this campaign template to be published to:</p>
            <client-published-campaign-template-table
                :templateId="templateId"
                @update:selectedItems="updateSelectedClients($event)"
            ></client-published-campaign-template-table>
        </div>
        <div class="widget-footer">
            <div class="cancel-container">
                <app-button class="transparent-btn" @click="closeWidget">Cancel</app-button>
            </div>
            <div class="action-container">
                <app-button @click="save" :loading="isSaving">
                    {{ isSaving ? 'Saving' : 'Save' }}
                </app-button>
            </div>
        </div>
    </div>
</template>

<script>
const AppButton = () => import('@/components/common/app-button');
const ClientPublishedCampaignTemplateTable = () => import('@/components/client/client-published-campaign-template-table');
const WidgetCloseSvg = () => import('@/components/svg/quick-add/widget-close-svg');
const LoadingScreenSvg = () => import('@/components/svg/loading-screen-svg');

import EventBus from '@/scripts/event-bus.js';

export default {
    name: 'template-publish-widget',

    props: ['options', 'widget'],

    components: {
        'app-button': AppButton,
        'client-published-campaign-template-table': ClientPublishedCampaignTemplateTable,
        'widget-close-svg': WidgetCloseSvg,
        'loading-screen-svg': LoadingScreenSvg
    },

    data() {
        return {
            isInitializing: true,
            isSaving: false,
            templateId: null,
            agencyId: null,
            selectedClients: []
        }
    },

    computed: {
        
    },

    methods: {
        updateSelectedClients(selectedClients) {
            this.selectedClients = selectedClients;
        },

        save() {  
            this.isSaving = true;
            var clientIds = this.selectedClients.map(client => { return client.id });

            this.$api
                .post(`/api/Templates/${ this.templateId }/Publish`, clientIds)
                .then(response => {
                    this.$helpers.showSuccessNotification('Your publish settings have been updated.');
                    this.isSaving = false;
                    
                    EventBus.$emit('template:update');
                    this.closeWidget();
                })
                .catch(error => {
                    this.$helpers.showFailNotification('An error occurred while saving your publish settings.', { error });
                    this.isSaving = false;
                });          
        },

        getTemplate() {
            this.$api
                .get(`/service/Templates/?$filter=Id eq ${ this.templateId }`)
                .then(response => {
                    this.agencyId = response.data.value[0].AgencyId;                    
                    this.isInitializing = false;
                })
                .catch(error => {
                    this.$helpers.showFailNotification('An error occurred while getting your template settings.', { error });
                    this.closeWidget();
                    this.isInitializing = false;
                }); 
        },

        closeWidget() {
            EventBus.$emit('close-widget', this.widget);
        }
    },

    created() {
        this.templateId = this.options.templateId;
        this.getTemplate();
    },

    destroyed() {
        
    }
}
</script>

<style scoped>
.template-publish-widget .saving-step {
    text-align: center;
}

.template-publish-widget .content-wrapper {
    padding: 20px;
}

.template-publish-widget .action-container {
    display: flex;
}

.template-publish-widget .action-container .btn {
    margin-left: 15px;
}

.template-publish-widget .cancel-container .btn.transparent-btn {
    background: transparent;
    color: #877D88;
}

.template-publish-widget .cancel-container .btn.transparent-btn:hover {
    background: #E1E0E5;
}

.template-publish-widget .action-container .btn.white-btn {
    background: #FFFFFF;
    color: #877D88;
    border: 2px solid #E9E9EF;
}
</style>
